<template>
    <el-select :multiple="multiple" v-model="data"   @change="change" :size="size" :placeholder="placeholder" >
        <el-option
                v-for="item in list"
                :key="item.dicCode"
                :label="item.dicName"
                :value="item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "order-type",
        props:{
            size:String,
            placeholder:String,
            multiple:Boolean,
            value:[Array,Object,String],
            type:String
        },
        model:{
            prop:'value'
        },
        data(){
            return{
                list:[],
                data:null,
            }
        },
        watch:{
            value(newval,oldval){
                this.data=this.value;
            }
        },
        mounted(){
            this.getData();
            this.data=this.value;

        },
        methods:{
            getData(){
                this.$axios.post("/order/orderTypeCode/",{
                    "storeId": this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log(res.data.list)
                    this.list=res.data.list;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },

            change(value){
                console.log(value)
                var data= this.list.filter((item)=>item.dicCode==value);
                this.$emit('change',data[0]);
                this.$emit('input',value)
            }
        }
    }
</script>

<style scoped>

</style>